import React from 'react';

import CartItem from './CartItem';
import { ICartItem } from '../../../CartProvider';
import clsx from 'clsx';

interface CartItemListProps {
  items: ICartItem[];
  onEdit?: (id: ICartItem['id']) => void;
  onDelete: (id: ICartItem['id']) => void;
  onQuantityChange: (id: ICartItem['id'], newQuantity: number) => void;
  className?: string;
}

const CartItemList: React.FC<CartItemListProps> = ({
  items,
  onEdit,
  onDelete,
  onQuantityChange,
  className,
}) => {
  return (
    <div className={clsx('flex flex-col gap-4', className)}>
      {items.map((item) => (
        <CartItem
          key={item.id}
          item={item}
          {...(onEdit ? { onEdit: () => onEdit(item.id) } : {})}
          onDelete={() =>
            onDelete(
              item.category === 'Access'
                ? item.item_details?.offering_id
                : item.id,
            )
          }
          onQuantityChange={(newQty) => onQuantityChange(item.id, newQty)}
        />
      ))}
    </div>
  );
};

export default CartItemList;
